import { render, staticRenderFns } from "./mergesuccessDialog.vue?vue&type=template&id=2864fb3e&scoped=true&"
import script from "./mergesuccessDialog.vue?vue&type=script&lang=js&"
export * from "./mergesuccessDialog.vue?vue&type=script&lang=js&"
import style0 from "./mergesuccessDialog.vue?vue&type=style&index=0&id=2864fb3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864fb3e",
  null
  
)

export default component.exports